import { render, staticRenderFns } from "./TongHopDtLnTlCtDuLieuBaoCao.vue?vue&type=template&id=6b51e794&scoped=true"
import script from "./TongHopDtLnTlCtDuLieuBaoCao.vue?vue&type=script&lang=ts"
export * from "./TongHopDtLnTlCtDuLieuBaoCao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51e794",
  null
  
)

export default component.exports